// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-main-container {
    display: flex;
    background: #fff;
    width: max-content;
    max-height: 460px;
    width: 100%;
    overflow-y: auto;
    user-select: none;
}
#table{
    width: 100%;
    text-align: center;
    border-collapse: collapse;
}
#table tr:first-child{
    width: 100px;
}
#table tr td{
    padding: 7px 40px 7px 10px;
    border-collapse: collapse;
    border: 1px solid #E5E5E5;
}
#table tr{
    cursor: pointer;
}
#table tr.active{
    background: #BCDEFF;
}
.isbad{
    opacity: 50%;
    font-style: italic;
}

.interpol-main-container{
    padding: 23px 28px;
    background: #fff;
}
.interpol-up-content{
    display: flex;
    align-items: center;
    padding-bottom: 15px;
}
.interpol-up-content span{
    padding: 0 10px;
}
.interpol-up-content input,
.interpol-up-content select {
    width: 100px;
    height: 27px;
    border: 1px #000 solid;
}

.dropdown-list {
    border: 1px solid #000;
    padding: 0;
    margin: 0;
    background-color: #fff;
}

.dropdown-list li {
    font-family: Roboto, sans-serif, Tahoma;
    cursor: pointer;
    list-style: none;
    font-size: 16px;
    border-bottom: 1px solid #000;
    padding: 5px;
}

.dropdown-list li:last-child {
    border-bottom: none;
}

.dropdown-list li:hover {
    color: #fff;
    background-color: #1E90FF;
}

.modal-template-wrap {
    box-sizing: border-box;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #8C8C8C;
}
.select-wrap {
    display: flex;
    flex-direction: column;
}

.modal-input-upload {
    display: none;
}

.modal-input-upload {
    width: 186px;
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/controls/trend/table/table.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;;IAEI,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".table-main-container {\r\n    display: flex;\r\n    background: #fff;\r\n    width: max-content;\r\n    max-height: 460px;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n    user-select: none;\r\n}\r\n#table{\r\n    width: 100%;\r\n    text-align: center;\r\n    border-collapse: collapse;\r\n}\r\n#table tr:first-child{\r\n    width: 100px;\r\n}\r\n#table tr td{\r\n    padding: 7px 40px 7px 10px;\r\n    border-collapse: collapse;\r\n    border: 1px solid #E5E5E5;\r\n}\r\n#table tr{\r\n    cursor: pointer;\r\n}\r\n#table tr.active{\r\n    background: #BCDEFF;\r\n}\r\n.isbad{\r\n    opacity: 50%;\r\n    font-style: italic;\r\n}\r\n\r\n.interpol-main-container{\r\n    padding: 23px 28px;\r\n    background: #fff;\r\n}\r\n.interpol-up-content{\r\n    display: flex;\r\n    align-items: center;\r\n    padding-bottom: 15px;\r\n}\r\n.interpol-up-content span{\r\n    padding: 0 10px;\r\n}\r\n.interpol-up-content input,\r\n.interpol-up-content select {\r\n    width: 100px;\r\n    height: 27px;\r\n    border: 1px #000 solid;\r\n}\r\n\r\n.dropdown-list {\r\n    border: 1px solid #000;\r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: #fff;\r\n}\r\n\r\n.dropdown-list li {\r\n    font-family: Roboto, sans-serif, Tahoma;\r\n    cursor: pointer;\r\n    list-style: none;\r\n    font-size: 16px;\r\n    border-bottom: 1px solid #000;\r\n    padding: 5px;\r\n}\r\n\r\n.dropdown-list li:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.dropdown-list li:hover {\r\n    color: #fff;\r\n    background-color: #1E90FF;\r\n}\r\n\r\n.modal-template-wrap {\r\n    box-sizing: border-box;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    border: 1px solid #8C8C8C;\r\n}\r\n.select-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.modal-input-upload {\r\n    display: none;\r\n}\r\n\r\n.modal-input-upload {\r\n    width: 186px;\r\n    height: 24px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
